
<template>
<div class="im-box" :class="{'show': imShow}">
    <div class="im-box-header">
        <p class="im-box-header-text">{{$t('im.header')}}</p>
        <i class="iconfont iconcha" @click="closeIm"></i>
    </div>
    <iframe :src="imUrl" width="500" height="490" id="imIframe" frameborder="0"></iframe>
</div>
</template>
<script>
    import { mapGetters } from "vuex";
    export default {
        data() {
            return {
                imShow: false,
                imUrl: '',
                src: ''
            };
        },
      methods: {
            closeIm() {
                this.imShow = false
            },
            openIm() {
                const uid = this.$store.state.user.uid?this.$store.state.user.uid:sessionStorage.getItem('deviceId')
                const session = {
                    // source: this.$store.state.imSource,
                    nickName: this.$store.state.user.uid?this.$store.state.user.showName:'游客',
                    name: this.$store.state.user.uid?this.$store.state.user.showName:'',
                    avatarUrl: this.$store.state.user.uid?this.$store.state.user.avatar:'https://public.lawback.com/lawback/user_avatar/default_avatar.png',
                    avatar:this.$store.state.user.uid?this.$store.state.user.avatar:'',
                    uid: uid,
                    openid: uid,
                    mobile: this.$store.state.user.uid?this.$store.state.user.phone:'',
                    rev:new Date().getTime(),
                    source: this.$store.state.locale=='zh_CN'?'第五届商法论坛':'The Fifth ICLCF'
                };
                this.imUrl = this.createUrl(session)
                this.imShow = true
            },
            createUrl(params) {
                const res = [];
              console.log(this.$store.state.locale)
                this.src =this.$store.state.locale=='zh_CN'? 'https://h5consult.lawback.com/s/613562ha7?':'https://h5consult.lawback.com/s/61358qh0i?'
                Object.keys(params).forEach(k => {
                    res.push(`${k}=${params[k]}`)
                })
                this.src = this.src + res.join('&')
                return this.src
                // return encodeURIComponent(url)
            },
        },
    }
</script>
<style lang='scss' scoped>
    .im-box {
        width: 500px;
        height: 540px;
        position: fixed;
        right: -750px;
        bottom: -750px;
        background-color: #f5f5f5;
        border-radius: 10px;
        overflow: hidden;
        z-index: 99999999;
        transition: all .3s;
        box-shadow: 0px 0px 13px 0px rgba(143, 143, 143, 0.24);
        padding-top: 50px;

        &.show {
            right: 100px;
            bottom: 70px;
            transition: all .3s;
        }

        .im-box-header {
            position: absolute;
            background: #fff;
            min-height: 50px;
            width: 100%;
            display: flex;
            //align-items: center;
            justify-content: space-between;
            padding: 10px 0;
            padding-left: 30px;
            padding-right: 20px;
            border-bottom: 1px solid #EAEAEA;
            top: 0;

            .im-box-header-text {
              font-size: 16px;
              font-weight:500;
              color: #333;
              letter-spacing: 0px;
              margin-bottom: 0;
              font-family: Source Han Sans CN;
            }

            .iconcha {
                color: #727272;
                cursor: pointer;
            }
        }
    }
</style>
